!function($) {
  
  

  // Add custom JavasScript here
  // --------------------------

  // Document ready
  $(function() {
    if(document.getElementById("onPageHourCode")){
    var hour = document.getElementById("onPageHourCode").value;
    }
     
    if(document.getElementById("onPageDayCode")) {
    var day = document.getElementById("onPageDayCode").value;
    }
   
    
    if ( hour > 11) {
      if (day =='Fri') {
      	var addDays = 4 // This caters for friday afternoon, delivery sent out monday
      }else{
          if (day =='Sat') {
      			var addDays = 3 // This caters for saturday Afternoon, delivery sent out monday
        	}else{
        	var addDays = 2 // any other day afternoon orders sent the following day
           }
      }
    }else {
        if (day =='Sat') {
          var addDays = 3 // Saturday morning orders, delivery sent out monday AM 
        }else{
            if (day =='Sun') {
          		var addDays = 2
          	} else {
      			var addDays = 1 // Any other day orders send out the same day.
     	 	}
        }
    }
    //var array = ["2021-08-31","2021-06-01","2021-05-04","2021-04-06","2021-04-02","2021-03-01","2021-03-08","2021-03-15","2021-03-22","2021-03-29","2021-04-05","2021-04-12","2021-04-19","2021-04-26","2021-05-10","2021-05-17","2021-05-24","2021-05-31","2021-06-07","2021-06-14","2021-06-21","2021-06-28","2021-07-05","2021-07-12","2021-07-19","2021-07-26","2021-08-02","2021-08-09","2021-08-16","2021-08-23","2021-08-30"]
    
	$("#delivery-date").datepicker( {
  
          minDate: +addDays,
          maxDate: '+30W',
          
  beforeShowDay: function(date){
    	var day = date.getDay();
        var string = jQuery.datepicker.formatDate('yy-mm-dd', date);
        return blockeddeliverydates.indexOf(string) != -1 ? [false] : [(day != 0), ''];
    //$.datepicker.noWeekends(date)
    
    },
  		  dateFormat: "dd/mm/yy"
        } );
    
  });
  
  

  
  

  
var acc = document.getElementsByClassName("accordionMR");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}

  
}(jQuery);


/* Toggle between adding and removing the "responsive" class to topnav when the user clicks on the icon */
function toggleMobileNav() {
    var x = document.getElementById("navbar");
  var y = document.getElementById("app-body");
  var z = document.getElementById("shopify-section-footer footer-section");
  
    if (x.className === "navbar") {
        x.className += " responsive";
      	//y.className += " menu-nudge";
      	
    } else {
        x.className = "navbar";
      	//y.className = "app-body";
      	
    }
  
  
    
}


 